import React from "react";
import AwardsContainer from "../../components/awards/awards-container";

const DisbursementsAwardsPage = () => {
    return <AwardsContainer pageId={"disbursementsAwards"} />;
};

export default DisbursementsAwardsPage;
